import { http } from "Utils/http";
import { Form, Col, Row, Spinner, Button } from 'react-bootstrap';
import {TextButton, IconTextButton, IconButton} from 'Components/Button';
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import {store} from 'Store';
import { useState, useEffect,useReducer } from "react";
import { useSelector, useDispatch } from "react-redux";
import {useParams, useLocation, useNavigate } from 'react-router-dom';
import { formatDate, isInObject } from "Utils/utilityFunctions";
import DatatableDropdownEntryField from "Components/Datatable/DatatableComponents/DatatableDropdownEntryField";
import DatatableDropdownCheckboxesField from "Components/Datatable/DatatableComponents/DatatableDropdownCheckboxesField";
import { FilterDrama } from "@mui/icons-material";
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import { ERROR_MESSAGES } from "Utils/constants";
import { httpDownload } from "Utils/httpDownload";
import Download from '@mui/icons-material/FileDownloadOutlined';
import { ICONS } from "Utils/icons";
import DatatableBaseStatic from "Components/Datatable/DatatableBaseStatic";




const OrganizationSummaryTable = ({ ...props}) => {
    // Date format: mm/dd/yyyy hh: mm
    const loginInfo = useSelector(state => state.loginInfo);
    //console.log(loginInfo);

    let location = useLocation();
    
    const navigate = useNavigate();
    
    const dispatch = useDispatch();
  

    const [sortColumn, setSortColumn] = useState({
        sortField: "",
        sortDirection: "desc"
    });

    const [filter, setFilter] = useState(null);
    const [docFilter, setDocFilter] = useState(null);
  
    useEffect(()=>{
        var passedData = location.state;
        
        if(isInObject("filter",passedData)) {
            //console.log("setFilter");
            //console.log(passedData.filter);
            setFilter(passedData.filter);
        }
        else {
            setFilter({
                startIndex:0,
                entryPerPage:10,
                sortingColumn:sortColumn.sortField,
                sortingOrder:sortColumn.sortDirection,
                searchTerm:""
            });
        }
        //console.log(filter);
        //console.log(docFilter);
    },[])



    const getTest = async (filter) => {   
        var call = filter;
        
        //console.log("CALL");
        //console.log(call);
        var url = '/api/dashboard/organizationSummary';
        
        return http.post(url, call,{
            headers: {
                "Authorization": "Bearer " + loginInfo.token
            }
        });
    }


    


    const getListCols = (selectedList, sortingInfo)=>{
        const listColumns = [];

        

        listColumns.push(Datatable_Column({
            name:"Listed PSOs", 
            columnName:"numOfPSOs", 
            selectedRows: selectedList, 
            sortable:false, 
            sortingInfo:sortingInfo
            
        }))
        listColumns.push(Datatable_Column({
            name:"Active DUAs", 
            columnName: "numOfDUAs",
            selectedRows: selectedList, 
            sortable:false, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"PSOs Submitted Patient Safety Data", 
            columnName:"numofPSOSubmitters", 
            selectedRows: selectedList, 
            sortable:false, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"Authorized Vendors", 
            columnName:"numOfVendors", 
            selectedRows: selectedList, 
            sortable:false, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"Active Help Center Users", 
            columnName:"numOfCommunityUsers", 
            selectedRows: selectedList, 
            sortable:false, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"Active Level 2 Users", 
            columnName:"numOfLevel2Users", 
            selectedRows: selectedList, 
            sortable:false, 
            sortingInfo:sortingInfo
        }))

        listColumns.push(Datatable_Column({
            name:"Active Level 3 Users", 
            columnName:"numOfLevel3Users", 
            selectedRows: selectedList, 
            sortable:false, 
            sortingInfo:sortingInfo
            
        }))

        
        return listColumns;
      }

      const tableTitle = function () {
        return null;
      }
      
      const tableDescription = function() {
        return null;
      }
      const [selectedCount, setSelectedCount] = useState(0);


    

  return (
    <>
       
        { filter!=null ?
        <DatatableBaseStatic
                tableClassName="orgSummaryDashTable" 
                getData={getTest} 
                
                filter = {filter}
                setFilter={setFilter}

                getListCols={getListCols} 
                setSelectedCount={setSelectedCount} 
                hasSelectableRows={false} 
                searchFieldText={"Search by document display name."} 
                
                datatableHeader={tableTitle()} 
                datatableDescription={tableDescription()}
                sortingColumn={sortColumn.sortField} 
                sortingOrder={sortColumn.sortDirection}
                striped={true}
            >
                    
               
            
            </DatatableBaseStatic>
            :null
        }  
    </>
  );
}

export default OrganizationSummaryTable;